import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoTabProvider } from "react-auto-tab";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import { getSupplierBranch, getSupplierFullName, getSupplierMainContactFullName, mapMstToOptions } from "utils/HelperFunction";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { Visibility } from "@mui/icons-material";
import { Avatar, Stack } from "@mui/material";
import { partnerData } from "mocks/partnerData";
export function ContractAttach() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState1[0], setOptionsDistributorgroup = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState2[0], setOptionsGroupOfSuplier = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState3[0], setSelectedGroupOfSuplierID = _useState3[1];
    var _useState4 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState4[0], setGroupOfSupplier = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), distributorgroup = _useState5[0], setDistributorgroup = _useState5[1];
    var columns = [
        {
            name: "รหัส Partner",
            selector: function(row) {
                return row.partnerCode;
            },
            width: "170px",
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_partner/view/" + row.id,
                        children: row.partnerCode ? row.partnerCode : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "รหัส VENDOR",
            selector: function(row) {
                return row.vendorCode;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_partner/view/" + row.id,
                        children: row.vendorCode ? row.vendorCode : "-"
                    })
                });
            },
            width: "170px",
            center: "true"
        },
        {
            name: "วันที่ขออนุมัติ",
            selector: function(row) {
                return row.dateSend ? row.dateSend : "-";
            },
            center: "true"
        },
        {
            name: "ชื่อธุรกิจ",
            selector: function(row) {
                return row.nameCompany ? row.nameCompany : "-";
            }
        },
        {
            name: "เลขผู้เสียภาษี",
            selector: function(row) {
                var _row_taxCode;
                return (_row_taxCode = row.taxCode) !== null && _row_taxCode !== void 0 ? _row_taxCode : "-";
            },
            center: "true"
        },
        {
            name: "ประเภท",
            selector: function(row) {
                return row.typeCompany ? row.typeCompany : "-";
            },
            center: "true"
        },
        {
            name: "จำนวนสินค้าที่นำเสนอ",
            selector: function(row) {
                return row.qty && row.qty > 0 ? row.qty : "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.statusId;
            },
            center: "true",
            width: "130px",
            cell: function(row, index, column, id) {
                return row.statusId == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(211, 47, 47, 1)",
                        backgroundColor: "rgba(253, 237, 237, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: row.statusName
                }) : row.statusId == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: row.statusName
                }) : row.statusId == 1 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: row.statusName
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: row.statusName
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "row",
                    spacing: 1,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_partner/view/" + row.id,
                        children: row.id ? /*#__PURE__*/ _jsx(Avatar, {
                            sx: {
                                color: "rgba(253, 180, 40, 1)",
                                bgcolor: "rgba(255, 246, 229, 1)"
                            },
                            children: /*#__PURE__*/ _jsx(Visibility, {
                                sx: {
                                    fontSize: 30
                                }
                            })
                        }) : "-"
                    })
                });
            },
            width: "170px",
            center: "true"
        }
    ];
    var _useState6 = _sliced_to_array(useState(""), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    var _useState7 = _sliced_to_array(useState(partnerData), 2), filteredItems = _useState7[0], setFilteredItems = _useState7[1];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ Partner"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "รายละเอียด",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "h3",
                            children: "จัดการ Partner"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                to: "/manage_partner",
                                className: "btn-category px-4 text-decoration-none active",
                                children: "ทั้งหมด"
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                to: "#",
                                className: "btn-category text-decoration-none px-4",
                                children: "รออนุมัติ"
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                to: "#",
                                className: "btn-category text-decoration-none px-4",
                                children: "อนุมัติ"
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                to: "#",
                                className: "btn-category text-decoration-none px-4",
                                children: "รอแก้ไข"
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                to: "#",
                                className: "btn-category text-decoration-none px-4",
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: filteredItems,
                                    filename: "manage_partner"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหารหัส Partner,รหัส VENDOR, ชื่อธุรกิจ, เลขผู้เสียภาษี",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
